import {formatCountdownTime} from './date-time-utils';

export interface ResendButtonOptions {
  isResending: boolean;
  canResend: boolean;
  timeLeft: number;
  resendingText?: string;
  resendText?: string;
  countdownPrefix?: string;
}

export const getResendButtonText = (options: ResendButtonOptions): string => {
  const {
    isResending,
    canResend,
    timeLeft,
    resendingText = 'Resending...',
    resendText = 'Resend verification code',
    countdownPrefix = 'Resend in ',
  } = options;

  if (isResending) return resendingText;
  if (canResend) return resendText;
  return `${countdownPrefix}${formatCountdownTime(timeLeft)}`;
};

export const getResendButtonState = (isResending: boolean, canResend: boolean) => ({
  disabled: isResending || !canResend,
  loading: isResending,
});
